import { Backdrop, Box, Divider, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { AddressSelector } from '../../../../store/Address'
import { AmericanStatesSelector } from '../../../../store/AmericanStates'
import { WaterSystemCoordinatesSelector } from '../../../../store/publicWaterSystem'
import { UtilityDetailSelector } from '../../../../store/utilityDetails'
import { WaterSystemsActions, WaterSystemsSelector } from '../../../../store/waterSystems'
import { useStyles } from '../../../../theme/styles'
import { handleMapZoomOnZip } from '../../../../utils/mapHelper'
import { CustomButton } from '../../../Button'
import { CloseIcon } from '../../../icons/CloseIcon'
import { Loader } from '../Loader'
import FilterComponent from './components/FilterComponent'
import RadiusComponent from './components/RadiusComponent'
import UtilityCardWidget from './components/UtilityCardWidget'
import { MapRefProps } from '../../../../views'
import { AppSelector } from '../../../../store/app'

interface UtilityDetailProps {
  onClose: (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => void
  setPopupPosition?: (position: { x: number; y: number } | null) => void
  setPopupDetails?: (details: any) => void
  setFillColor?: (color: string) => void
  mapRef: React.MutableRefObject<MapRefProps | null>

}

export const UtilityDetail: React.FC<UtilityDetailProps> = ({
  onClose,
  mapRef,

}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const selectedAddress = useSelector(AddressSelector.selectAddress)
  const americanStates = useSelector(AmericanStatesSelector.getStates)
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const styles = useStyles()
  const [sortOrder, setSortOrder] = useState('highest')
  const utilityOpen = useSelector(AppSelector.getMapDataDrawerState)
  const utilityDetailOpen = useSelector(UtilityDetailSelector.getShowDrawer)

  const waterSystemsLoading = useSelector(WaterSystemsSelector.isLoading)


  const handleSortChange = (value: string) => {
    setSortOrder(value)
  }

  const handleRadiusChange = async (value: number) => {
    try {
      if (!selectedAddress) return
      setIsLoading(true)

      const resultAction = await dispatch(
        WaterSystemsActions.fetchPublicWaterSystemsByAddressAsync({
          latitude: selectedAddress.latitude,
          longitude: selectedAddress.longitude,
          radius: value,
        }) as any,
      )

      if (WaterSystemsActions.fetchPublicWaterSystemsByAddressAsync.fulfilled.match(resultAction)) {
        handleMapZoomOnZip(resultAction.payload, americanStates, dispatch)
      }

      dispatch(WaterSystemsActions.setUserSearched(true))
    } catch (error) {
      console.error('Error fetching public water systems by address:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      sx={{
        ...styles.scrollbar,
        flexShrink: 1,
        position: 'relative',
        transition: 'width 0.3s linear',
        bgcolor: '#FFFFFF',
        overflow: 'hidden',
        width: isMobile ? '100%' : utilityOpen || utilityDetailOpen ? '30vw' : '0px',
      }}
    >


      <Stack sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '30vw',
         }}>
        <Backdrop
          open={waterSystemsLoading}

          sx={{
            backgroundColor: 'rgba(0,0,0,0.2)',
            backdropFilter: 'blur(1px)',
            position: 'absolute',
            transition: 'none',
            width: '100%',
            minWidth: '30vw',
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Loader size="large" />
        </Backdrop>

        {/* Fixed Header*/}
        <Stack gap={2} p={3} sx={{ pb: 0, width: '100%' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="text.primary" fontWeight={600}>
              Utilities near you
            </Typography>
            <IconButton onClick={onClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
        </Stack>
         {/*Scrollable Content*/}

        <Box sx={{ flexShrink: 1, mr: 1, overflow: 'auto', ...styles.scrollbar }}>
          <Stack gap={2} p={3}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <FilterComponent onSortChange={handleSortChange} />
              <RadiusComponent onRadiusChange={handleRadiusChange} isLoading={isLoading} />
            </Box>
            <UtilityCardWidget
              sortOrder={sortOrder}
              mapRef={mapRef}
            />
          </Stack>
        </Box>


         {/*Fixed Button*/}
        <Box sx={{ pt: 2, p: 2, mt: 'auto' }}>
          <CustomButton fullWidth onClick={() => navigate('/test-strip')} text="Test Your Water" />
        </Box>
      </Stack>

    </Box>
  )
}
